(() => {
  'use strict';
  const root = document.querySelector('[data-product-discovery]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const config = JSON.parse(root.querySelector('[data-product-discovery-config]').textContent);
  const status = root.querySelector('[data-discovery-status]');
  const retry = root.querySelector('[data-discovery-retry]');
  const sizes = '(min-width: 1220px) 280px, (min-width: 761px) 23vw, 46vw';
  let loading = false;
  let loaded = false;
  const shopRoot = window.Shopify?.routes?.root || '/';
  let cartNotice;
  let cartMessage;

  function announceCart(message) {
    if (!cartNotice) {
      cartNotice = document.createElement('div');
      cartNotice.className = 'product-discovery-cart-notice';
      cartMessage = document.createElement('span');
      cartMessage.setAttribute('role', 'status');
      cartMessage.setAttribute('aria-live', 'polite');
      const cartLink = document.createElement('a');
      cartLink.href = `${shopRoot}cart`;
      cartLink.textContent = 'View cart';
      const dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.setAttribute('aria-label', 'Close cart message');
      dismiss.textContent = '×';
      dismiss.addEventListener('click', () => { cartNotice.hidden = true; });
      cartNotice.append(cartMessage, cartLink, dismiss);
      document.body.append(cartNotice);
    }
    cartNotice.hidden = false;
    cartMessage.textContent = message;
  }

  function cartIcon() {
    const ns = 'http://www.w3.org/2000/svg';
    const icon = document.createElementNS(ns, 'svg');
    icon.setAttribute('width', '18');
    icon.setAttribute('height', '18');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '1.5');
    icon.setAttribute('stroke-linecap', 'round');
    icon.setAttribute('stroke-linejoin', 'round');
    icon.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M3 3h2l2.4 11.4a2 2 0 0 0 2 1.6H18a2 2 0 0 0 2-1.6L21 7H6M14 3v6m-3-3h6');
    icon.append(path);
    [10, 18].forEach(x => {
      const wheel = document.createElementNS(ns, 'circle');
      wheel.setAttribute('cx', String(x));
      wheel.setAttribute('cy', '20');
      wheel.setAttribute('r', '1');
      icon.append(wheel);
    });
    return icon;
  }

  function quickAdd(product) {
    const validVariant = /^\d+$/.test(String(product.variantId || ''));
    const chooseOptions = product.available !== false && (!validVariant || product.hasOnlyDefaultVariant === false);
    const control = document.createElement(chooseOptions ? 'a' : 'button');
    control.className = 'm27-recommendation-card__quick-add';
    const label = product.available === false ? `${product.title} is sold out` : chooseOptions ? `Choose options for ${product.title}` : `Add ${product.title} to cart`;
    control.setAttribute('aria-label', label);
    control.title = product.available === false ? 'Sold out' : chooseOptions ? 'Choose options' : 'Add to cart';
    control.append(cartIcon());
    if (chooseOptions) {
      control.href = product.url;
      return control;
    }
    control.type = 'submit';
    control.disabled = product.available === false || !validVariant;
    const check = document.createElement('span');
    check.className = 'm27-recommendation-card__added';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    control.append(check);
    const form = document.createElement('form');
    form.className = 'm27-recommendation-card__cart';
    form.dataset.discoveryQuickAdd = '';
    form.method = 'post';
    form.action = `${shopRoot}cart/add`;
    [['id', product.variantId || ''], ['quantity', '1'], ['return_to', `${shopRoot}cart`]].forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.append(input);
    });
    form.append(control);
    return form;
  }

  // Delegation also covers cards appended by the lazy-loading batches.
  root.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-discovery-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) {
        announceCart(result.description || result.message || 'This item could not be added. Please check your cart.');
        return;
      }
      button.classList.add('is-added');
      announceCart('Added to your cart');
      setTimeout(() => button.classList.remove('is-added'), 2000);
      fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(response => response.ok ? response.json() : null)
        .then(cart => {
          if (!cart || !Number.isInteger(cart.item_count)) return;
          document.querySelectorAll('.m27-header-cart__count').forEach(count => { count.textContent = String(cart.item_count); });
          document.querySelectorAll('a.m27-header-cart').forEach(link => { link.setAttribute('aria-label', `Cart, ${cart.item_count} items`); });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        }).catch(() => { /* Addition succeeded even if the badge refresh fails. */ });
    } catch (_) {
      announceCart('Could not confirm the addition. Check your cart before trying again.');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  // Keep a customer reading reviews in place when recommendations expand above.
  function preserveReviewPosition(update) {
    const reviews = document.querySelector('[data-product-reviews-bottom]');
    const before = reviews?.getBoundingClientRect();
    const nav = document.querySelector('[data-hz-product-navigation]');
    const readingLine = (nav?.getBoundingClientRect().bottom || 0) + 24;
    // Reviews appearing below an empty Explore area does not mean they are being read.
    const readingReviews = before && before.top <= readingLine && before.bottom > readingLine;
    update();
    if (readingReviews) {
      const shift = reviews.getBoundingClientRect().top - before.top;
      if (shift) window.scrollBy({ top: shift, behavior: 'instant' });
    }
  }

  const imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      loadImage(entry.target);
      imageObserver.unobserve(entry.target);
    });
  }, { rootMargin: '300px' }) : null;

  function loadImage(img) {
    img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
  }

  function card(product) {
    const article = document.createElement('article');
    article.className = 'm27-recommendation-card';
    article.dataset.productId = product.id;
    const media = document.createElement('a');
    media.className = 'm27-recommendation-card__media';
    media.href = product.url;
    media.setAttribute('aria-label', `View details: ${product.title}`);
    if (product.image) {
      const img = document.createElement('img');
      img.width = 560;
      img.height = 560;
      img.alt = product.image.alt;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.sizes = sizes;
      img.dataset.src = product.image.src;
      img.dataset.srcset = `${product.image.smallest} 180w, ${product.image.small} 280w, ${product.image.medium} 420w, ${product.image.src} 560w`;
      media.append(img);
      if (imageObserver) imageObserver.observe(img); else loadImage(img);
    }
    const title = document.createElement('h3');
    const link = document.createElement('a');
    link.href = product.url;
    link.textContent = product.title;
    title.append(link);
    const mediaWrap = document.createElement('div');
    mediaWrap.className = 'm27-recommendation-card__media-wrap';
    mediaWrap.append(media, quickAdd(product));
    article.append(mediaWrap, title);
    const score = Math.max(0, Math.min(5, Number(product.rating) || 0));
    const count = Math.max(0, Number(product.ratingCount) || 0);
    const hasReviews = score > 0 && count > 0;
    const rating = document.createElement('div');
    rating.className = `hz-card-rating${hasReviews ? '' : ' hz-card-rating--empty'}`;
    rating.setAttribute('role', 'img');
    rating.setAttribute('aria-label', hasReviews ? `Rated ${score} out of 5 stars, ${count} customer reviews` : 'No customer reviews yet');
    if (hasReviews) {
      const number = document.createElement('span');
      number.className = 'hz-card-rating__score';
      number.textContent = score.toFixed(1);
      number.setAttribute('aria-hidden', 'true');
      rating.append(number);
    }
    const stars = document.createElement('span');
    stars.className = 'hz-card-rating__stars';
    stars.style.setProperty('--hz-star-fill', `${hasReviews ? score * 20 : 0}%`);
    stars.setAttribute('aria-hidden', 'true');
    ['empty', 'filled'].forEach(type => {
      const layer = document.createElement('span');
      layer.className = `hz-card-rating__${type}-stars`;
      layer.textContent = '★★★★★';
      stars.append(layer);
    });
    const reviewCount = document.createElement('span');
    reviewCount.className = 'hz-card-rating__count';
    reviewCount.textContent = `(${hasReviews ? count : 0})`;
    reviewCount.setAttribute('aria-hidden', 'true');
    rating.append(stars, reviewCount);
    article.append(rating);
    if (product.monthlySalesLabel) {
      const monthlySales = document.createElement('p');
      monthlySales.className = 'hz-card-monthly-sales';
      monthlySales.textContent = `${product.monthlySalesLabel} bought in past month`;
      article.append(monthlySales);
    }
    const price = document.createElement('p');
    price.className = 'hz-card-price-row m27-recommendation-card__price';
    const strong = document.createElement('strong');
    strong.className = 'hz-card-price';
    strong.textContent = product.price;
    price.append(strong);
    if (product.compareAtPrice) {
      const typical = document.createElement('span');
      typical.className = 'hz-card-typical';
      const label = document.createElement('span');
      label.textContent = 'Typical price:';
      const original = document.createElement('s');
      original.textContent = product.compareAtPrice;
      typical.append(label, original);
      price.append(typical);
    }
    article.append(price);
    return article;
  }

  function renderGroup(name, products, description) {
    const section = root.querySelector(`[data-discovery-group="${name}"]`);
    const grid = section.querySelector('[data-discovery-grid]');
    const more = section.querySelector('[data-discovery-more]');
    section.querySelector('[data-discovery-count]').textContent = products.length ? `${products.length} products · ${description}` : (name === 'similar' ? 'No other products in this collection yet.' : 'You have explored all our other products.');
    grid.replaceChildren();
    section.dataset.total = products.length;
    let shown = 0;
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) appendBatch();
    }, { rootMargin: '200px' }) : null;
    function appendBatch() {
      const fragment = document.createDocumentFragment();
      products.slice(shown, shown + 8).forEach(product => fragment.append(card(product)));
      shown = Math.min(shown + 8, products.length);
      preserveReviewPosition(() => {
        grid.append(fragment);
        more.hidden = shown >= products.length;
      });
      if (more.hidden && observer) observer.disconnect();
      // Re-observe after layout so a short batch can continue filling the viewport.
      else if (observer) {
        observer.unobserve(more);
        requestAnimationFrame(() => observer.observe(more));
      }
    }
    more.onclick = appendBatch;
    appendBatch();
  }

  async function start() {
    if (loading || loaded) return;
    loading = true;
    retry.hidden = true;
    root.setAttribute('aria-busy', 'true');
    status.hidden = false;
    status.textContent = 'Loading products…';
    try {
      const products = new Map();
      const visited = new Set();
      let url = new URL(config.feed, location.origin);
      url.searchParams.set('section_id', 'product-catalog-feed');
      url.searchParams.set('page', '1');
      let expectedTotal = 0;
      while (url) {
        if (visited.has(url.href)) throw new Error('Catalog pagination repeated');
        visited.add(url.href);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const dataNode = doc.querySelector('[data-product-catalog-page]');
        if (!dataNode) throw new Error('Catalog feed unavailable');
        const data = JSON.parse(dataNode.textContent);
        expectedTotal = Number(data.total);
        data.products.forEach(product => products.set(String(product.id), product));
        if (data.next) {
          url = new URL(data.next, url);
          url.searchParams.set('section_id', 'product-catalog-feed');
        } else url = null;
      }
      if (products.size < expectedTotal) throw new Error('Incomplete catalog');
      const others = [...products.values()].filter(product => String(product.id) !== String(config.id));
      const collectionIds = new Set(config.collections.map(String));
      const similar = collectionIds.size ? others.filter(product => product.collections.some(id => collectionIds.has(String(id)))) : others.slice(0, 5);
      const similarIds = new Set(similar.map(product => String(product.id)));
      const remaining = others.filter(product => !similarIds.has(String(product.id)));
      preserveReviewPosition(() => {
        renderGroup('similar', similar, collectionIds.size ? 'From the same collections' : 'More builds to explore');
        renderGroup('other', remaining, 'More from our store');
        status.hidden = true;
      });
      root.dataset.catalogTotal = products.size;
      loaded = true;
    } catch (error) {
      status.textContent = 'Products could not load. Please try again.';
      retry.hidden = false;
      console.warn('Product discovery:', error.message);
    } finally {
      loading = false;
      root.setAttribute('aria-busy', 'false');
    }
  }
  retry.addEventListener('click', start);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); start(); }
    }, { rootMargin: '600px' });
    observer.observe(root);
  } else start();
})();
